import type { VFC } from 'react'
import type { WithRequiredTheme, WithStyleOverrides } from '../../gem'
import * as styles from './styles'

type ErrorMessageProps = Readonly<
  WithRequiredTheme &
    WithStyleOverrides & {
      message?: string
    }
>

export const ErrorMessage: VFC<ErrorMessageProps> = ({
  message = '',
  styleOverrides,
  theme,
}) => {
  if (message === '') return null

  return (
    <span
      aria-live="assertive"
      className={styles.classes.errorMessage}
      css={[
        styles.validationError({
          theme,
        }),
        styleOverrides,
      ]}
    >
      {message}
    </span>
  )
}
